module.exports = __webpack_public_path__ + "img/back-arrow.18e0490d.svg";